// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"_2oNAj","socialShareButtons":"_2oNAj","social-share-group":"_2ctpI","socialShareGroup":"_2ctpI","social-share-button":"uaVeX","socialShareButton":"uaVeX"};